module.exports = __webpack_public_path__ + "img/agapanthe_md.33498c8a.jpg";